// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__19zFG","addWidgetButton":"Header_addWidgetButton__2EvUM","dashboardTabs":"Header_dashboardTabs__kYNTA","active":"Header_active__3reX2"};